import { render } from "./BlogContent.vue?vue&type=template&id=21865dab&scoped=true&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import "./BlogContent.vue?vue&type=style&index=0&id=21865dab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21865dab"]])

export default __exports__